import { ChangeDetectionStrategy, Component, ContentChildren, forwardRef, QueryList, TemplateRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { PrimeTemplate } from 'primeng/api';


export const ORDERBUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => OrderButtonComponent),
  multi: true
};
@Component({
  selector: 'order-button',
  templateUrl: './order-button.component.html',
  styleUrls: ['./order-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ORDERBUTTON_VALUE_ACCESSOR]
})
export class OrderButtonComponent implements ControlValueAccessor {
  writeValue(obj: boolean): void {
    this.desc = obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  @ContentChildren(PrimeTemplate) templates: QueryList<PrimeTemplate>;
  contentTemplate: TemplateRef<any>;

  desc: boolean = false;
  onModelChange: Function = () => { };
  onModelTouch: Function = () => { };
  disabled: boolean = false;

  switchStatus(event) {
    if (this.disabled) return;
    this.desc = !this.desc;
    this.onModelChange(this.desc);
  }
  onblur(event) {
    this.onModelTouch();
  }

  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    if (this.templates && this.templates.length > 0) {
      this.contentTemplate = this.templates.find(it => it.getType() == 'content')?.template;
    }
  }
}
